import { OffcanvasDomain } from "../../../../_components/Abstractions/OffcanvasDomain";
import { useEffect, useState } from "react";
import { ContractorWasteKindForm } from "./ContractorWasteKindForm";
import { wastesActions } from "../../../../_store/wastes.slice";
import { useDispatch } from "react-redux";

export function ContractorWasteKindOffcanvas({ size, btnSize = "md", contractorId, addressId, wastes }) {
  const title = "Gatunki towarów";
  const dispatch = useDispatch();
  const [showOffCanvas, setShowOffCanvas] = useState(false);
  const defaultValues = {
    wastes: wastes?.map(x => ({
      waste: x.waste,
      wasteKinds: x.wasteKinds?.map(w => ({ wasteKindId: w.wasteKindId, name: w.name }))
    }))
  };

  const wastesIds = wastes?.map(x => x.waste.wasteId);
  const form = <ContractorWasteKindForm
    contractorId={contractorId}
    addressId={addressId}
    setShowOffCanvas={setShowOffCanvas}
    defaultValues={defaultValues} />;

  const onSearchChange = async() => {
    if (wastesIds.length === 0) {
      return;
    }

    await dispatch(wastesActions.searchWasteKinds({ wastesIds }));
  };

  useEffect(() => {
    if(!showOffCanvas) {
      return;
    }
    onSearchChange();
  }, [showOffCanvas]);

  return (
    <>
      <OffcanvasDomain
        setShowOffCanvas={setShowOffCanvas}
        showOffCanvas={showOffCanvas}
        btnVariant="outline-primary"
        size={size}
        btnSize={btnSize}
        buttonContent="Edytuj"
        title={title}
        // disabledBtnTrigger={isClone && !ratePlan?.dateTo}
        body={form}
      />
    </>);
}